import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  gap: 12px;
`;

export const TextCol = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.h2`
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 900;
  color: #000;
`;

export const Logo = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 8px;
  flex-shrink: 0;
`;
